var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconSelect = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(1.999 2)" },
                    React.createElement("path", { d: "M22.6,22.6L11.7,11.8" }),
                    React.createElement("path", { d: "M11.7,18.7v-7h6.9" })),
                React.createElement("g", { transform: "translate(24.666 -1.316) rotate(90)" },
                    React.createElement("path", { d: "M16.3-0.1H8.7c-1.2,0-2.2,1-2.2,2.2v15.2c0,1.2,1,2.2,2.2,2.2h15.2c1.2,0,2.2-1,2.2-2.2V9.7" }))))));
});
export default IconSelect;
//# sourceMappingURL=IconSelect.js.map